/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
export enum EnrollmentPeriodStatus {
  Passed = 'Passed',
  Active = 'Active',
  Planned = 'Planned'
}
